import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

const STORAGE_KEY = "sb_lang";
const SUPPORTED_LANGS = ["en", "es"] as const;
export type AppLang = (typeof SUPPORTED_LANGS)[number];

@Injectable({ providedIn: "root" })
export class I18nService {
  constructor(private readonly translate: TranslateService) {}

  init(): void {
    this.translate.addLangs([...SUPPORTED_LANGS]);
    this.translate.setDefaultLang("en");
    this.translate.use(this.resolveInitialLanguage());
  }

  get currentLang(): AppLang {
    const lang = (this.translate.currentLang || this.translate.getDefaultLang() || "en").toLowerCase();
    return this.normalize(lang);
  }

  setLanguage(lang: string): void {
    const normalized = this.normalize(lang);
    this.translate.use(normalized);
    localStorage.setItem(STORAGE_KEY, normalized);
  }

  get languages(): AppLang[] {
    return [...SUPPORTED_LANGS];
  }

  t(key: string, params?: Record<string, unknown>): string {
    return this.translate.instant(key, params);
  }

  private resolveInitialLanguage(): AppLang {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return this.normalize(saved);
    }
    const browser = (navigator.language || "en").toLowerCase();
    return this.normalize(browser);
  }

  private normalize(lang: string): AppLang {
    const short = lang.split("-")[0] as AppLang;
    return SUPPORTED_LANGS.includes(short) ? short : "en";
  }
}

